import React from 'react';
import { Form,  Input, Button,  Divider, message } from 'antd'
import { editPassword } from '@/request/api'
import { requestErrorLog } from '@/common/util'
class editPassWord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    //新密码一致校验
    handleCheckPwd(rules, value, callback) {
        let cfmPwd = this.props.form.getFieldValue('cfmloginpass');
        if (cfmPwd && cfmPwd !== value) {
            callback(new Error('两次密码输入不一致'))
        } else {

            // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
            callback();
        }
    }

    //确认密码校验一致
    handleCfmPwd(rules, value, callback) {
        let loginpass = this.props.form.getFieldValue('loginpass');
        if (loginpass && loginpass !== value) {
            callback(new Error('两次密码输入不一致'))
        } else {

            // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
            callback();
        }   
    }
    handleSubmit = () => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let param={
                    Type: 'ChangePassword',//修改   		
                    USER_UID:userInfo.USER_UID, // 用户uid
                    OLD_PASSWORD:values.oldPassword,//旧密码
                    PASSWORD:values.loginpass, // 修改的密码
                }
                editPassword(param).then((res) => {
                    if (res && res.Status === 1) {
                        if( res.Result === -1){
                            message.error('原密码输入错误！');
                            return;
                        }
                        else{
                            message.success("保存成功")
                        }
                    } else {
                     requestErrorLog('', '系统设置-修改密码-修改密码报错', 0, true)
                      message.error("请检查网络连接");
                    }
                  })
            }
        })
    }
    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        return (
            <Form {...formItemLayout} className="formWrap">
                <Divider orientation="left">修改密码</Divider>
                <Form.Item label="旧密码" style={{ width: '50%' }}>
                    {getFieldDecorator('oldPassword', {
                        rules: [{ required: true, message: '请输入旧密码' }],
                    })(<Input autoComplete="off" type="password" />)}
                </Form.Item>
                <Form.Item label="新密码" style={{ width: '50%' }}>
                    {getFieldDecorator('loginpass', {
                        rules: [{ required: true, message: '请输入新密码' }, {
                            validator: (rules, value, callback) => { this.handleCheckPwd(rules, value, callback) }
                        }],
                        validateFirst: true
                    })(<Input autoComplete="off" type="password" />)}
                </Form.Item>


                <Form.Item label="确认密码" style={{ width: '50%' }}>
                    {getFieldDecorator('cfmloginpass', {
                        rules: [{ required: true, message: '确认密码' }, {
                            validator: (rules, value, callback) => { this.handleCfmPwd(rules, value, callback) }
                        }],
                        validateFirst: true
                    })(<Input autoComplete="off" type="password" />)}
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 20 }}>
                    <Button type="primary" onClick={this.handleSubmit}>保存</Button>
                </Form.Item>
            </Form>
        );
    }
}

export default (Form.create({})(editPassWord));